﻿'use strict';

/*jslint bitwise: true */
angular.module('ntmApp').factory('UnAssignedActivities', ['ForecastService', 'UnAssignedActivitiesFilter', 'ForecastingFiltersProvider', 'Constants', 'ActivityUtils',
    function (ForecastService, UnAssignedActivitiesFilter, ForecastingFiltersProvider, Constants, ActivityUtils) {

    function UnAssignedActivities(context, mode) {

        var self = this;

        self.forecastMode = mode;
        self.tabs = [];
        self.selectedTab = {};

        self.filterSettings = {
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 10,
            scrollableHeight: '200px',
            enableSearch: true
        };

        self.multiSelectEvents = {
            onItemSelect: function () {
                self.applyFilter();
            },
            onItemDeselect: function () {
                self.applyFilter();
            },
            onDeselectAll: function () {
                self.applyFilter();
            }
        };

        var recurrs = [
            { id: 'Daily', value: 'Daily' },
            { id: 'Weekly', value: 'Weekly' },
            { id: 'Monthly', value: 'Monthly' },
            { id: 'Yearly', value: 'Yearly' },
            { id: 'One-Time', value: 'One-Time' }
        ];

        self.filter = new UnAssignedActivitiesFilter();

        self.load = function (header, selectedWeek, scenarioId, preventTabsRecreating) {

            if (!(self.tabs.length > 0 && preventTabsRecreating)) {
                self.generateTabs(selectedWeek.startDate, selectedWeek.endDate);
            }

            var data = {
                forecastView: header.forecastOptionsSummary.forecastView,
                forecastScope: header.selectedForecastScope.id.trim(),
                dateFrom: selectedWeek.startDate,
                dateTo: selectedWeek.endDate,
                forecastMode: self.forecastMode
            };

            if (scenarioId) {
                data.scenarioBreadcrumb = scenarioId;
            }

            self.isLoading = true;

            ForecastService.GetForecastUnAssignedActivitiesFilter(data).then(function (result) {

                if (result.success) {

                    self.filterData = result.data;
                    self.filterData.recurrs = recurrs;

                    self.isLoading = false;

                    ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                        if (filters) {
                            self.filterData.roomTypes = filters.roomTypeFilters;
                            self.filterData.species = filters.speciesFilters;
                        }
                    });
                }
            });

            self.tabs.forEach(function (tab) {
                loadTab(tab, header, scenarioId);
            });
        };

        self.reloadTabs = function (dates, header, scenarioId) {
            
            self.tabs.filter(function (tab) {
                return dates.some(function (date) {
                    return date.isSame(moment(tab.date), 'days');
                });
            }).forEach(function (tab) {
                loadTab(tab, header, scenarioId);
            });
        };

        function loadTab(tab, header, scenarioId) {

            tab.isLoading = true;

            var request = {
                forecastView: header.forecastOptionsSummary.forecastView,
                forecastScope: header.selectedForecastScope.id.trim(),
                date: tab.date,
                forecastMode: self.forecastMode
            };

            if (scenarioId) {
                request.scenarioBreadcrumb = scenarioId;
            }

            ForecastService.GetForecastUnAssignedActivitiesByDate(request).then(function (result) {

                if (result.success) {

                    if (result.data.unAssignedActivitiesGroup) {

                        tab.activities = result.data.unAssignedActivitiesGroup;
                        applyFilterToTab(tab);

                    } else {
                        clearTabInfo(tab);
                    }

                    tab.isLoading = false;
                }
            });

        }

        function clearTabInfo(tab) {
            tab.activities = undefined;
            tab.filteredGroupsByCategory = undefined;
            tab.totalHours = undefined;
            tab.count = undefined;
        }

        self.generateTabs = function (dateFrom, dateTo) {
            self.tabs = [];

            var currentDate = moment(dateFrom);
            var endDate = moment(dateTo);

            while (currentDate.diff(endDate, 'days') <= 0) {

                var tmplDate =  moment(currentDate).toDate();

                self.tabs.push({
                    dayLabel: getDayLabel(currentDate),
                    date: tmplDate,
                    dndTarget: []
                });

                currentDate.add(1, 'day');
            }

            self.selectedTab = self.tabs[0];
        };

        self.calculateTabWidth = function () {
            return 'width:{0}%'.format(98 / self.tabs.length);
        };

        self.defaultDragAndDropTargetsForTabs = function () {
            self.tabs.forEach(function (tab) {
                tab.dndTarget = [];
            });
        };

        self.selectTab = function (tab) {
            if (tab) {
                this.selectedTab = tab;
            }
        };

        self.isTabSelected = function (tab) {
            return self.selectedTab === tab;
        };

        self.applyFilter = function () {

            self.tabs.forEach(function (tab) {
                applyFilterToTab(tab);
            });
        };

        self.applyDurationFilterHours = function () {

            if (self.filter.DurationFilter.hours && !self.filter.DurationFilter.minutes) {
                self.filter.DurationFilter.minutes = 0;
            }

            self.applyFilter();
        };

        self.applyDurationFilterMinutes = function () {

            if (self.filter.DurationFilter.minutes && !self.filter.DurationFilter.hours) {
                self.filter.DurationFilter.hours = 0;
            }

            self.applyFilter();
        };

        function applyFilterToTab(tab) {

            var filtered = self.filter.filterActivities(tab.activities);
            var summary = groupsSummary(filtered);

            var activitiesGrouppedByCategory = ActivityUtils.GroupByCategories(filtered, function (group) {
                group.date = moment(tab.date);

                if (group.grouppedByLocate) {

                    group.groupsByLocate.forEach(function (byLocate) {
                        byLocate.date = moment(tab.date);
                        byLocate.icons = context.getUniqueIcons(byLocate.items);
                    });
                }

                group.icons = context.getUniqueIcons(group.getActivities());
            });

            activitiesGrouppedByCategory.syncExpandedState(tab.filteredGroupsByCategory);

            tab.filteredGroupsByCategory = activitiesGrouppedByCategory;
            tab.totalHours = summary.totalHours;
            tab.count = summary.count;
        }

        self.toggleFilter = function () {
            self.showFilter = !self.showFilter;
        };

        self.clearAllFilters = function () {
            self.filter.clearAllFilters();
            self.applyFilter();
        };

        self.clearFilter = function (filter) {
            filter.clear();
            self.applyFilter();
        };

        function getDayLabel(date) {
            var dayLabel = Constants.DayLabels.getLabel(date);

            var month = date.format('M');
            var day = date.format('D');

            return '{0}: {1}/{2}'.format(dayLabel, month, day);
        }

        function groupsSummary(activities) {

            return {
                count: activities.length,
                totalHours: (activities.sumOf('duration') / 60).toFixed(2)
            };
        }

        self.expandAllActivitiesOfSelectedDay = function () {
            self.selectedTab.filteredGroupsByCategory.setExpandedState(true);
        };

        self.collapseAllActivitiesOfSelectedDay = function () {
            self.selectedTab.filteredGroupsByCategory.setExpandedState(false);
        };
    }

    return (UnAssignedActivities);
}]);